export default function PIXMA_E4590() {

    return <>
        <p><img src="http://image.kr.canon/namo/binary/20220713112025628_LD23SKQK.jpg" width="98%" /></p>
        <p><img src="http://image.kr.canon/namo/binary/20220713112039590_VQW6TLC9.jpg" width="98%" /></p>
        <p><img src="http://image.kr.canon/namo/binary/20220713112052373_FWIKOBX3.jpg" width="98%" /></p>
        <p><img src="http://image.kr.canon/namo/binary/20220713112108366_LHHSE82Y.jpg" width="98%" /></p>
    </>
}